import { FC } from "react";
import { IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { OneMinuteTimerEvent, OneMinuteTimerType } from "refsix-js-models";
import { DisplayEvent } from "../../models/DisplayEvent";
import "../components.css";

interface RenderOneMinuteTimerLogInterface {
    displayEvent: DisplayEvent;
}

// REFSIX-819: a One Minute Timer row reads "1-Minute Timer · Injury · 21'".
// The timer's progress is never stored, so there is no duration to show.
export const RenderOneMinuteTimerLog: FC<RenderOneMinuteTimerLogInterface> = ({
    displayEvent,
}) => {
    const { t } = useTranslation();
    const timer = displayEvent.event as OneMinuteTimerEvent;
    const typeText =
        timer.timerType === OneMinuteTimerType.sub
            ? t("model.WatchFixture.oneMinuteTimerSub")
            : t("model.WatchFixture.oneMinuteTimerInjury");

    return (
        <div
            className="log-half-container"
            data-testid="match-log-one-minute-timer"
        >
            <div className="log-middle-wrapper">
                <IonText className="log-event-name-text">
                    {t("model.WatchFixture.oneMinuteTimerDisplayName")}
                </IonText>
                <IonText className="log-minute-play-text">{typeText}</IonText>
                <IonText className="log-minute-play-text">
                    {displayEvent.displayMinute}
                </IonText>
            </div>
        </div>
    );
};
